import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons/faCaretRight";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faFolder } from "@fortawesome/free-solid-svg-icons/faFolder";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faUnlock } from "@fortawesome/free-solid-svg-icons/faUnlock";

library.add(
	faBars,
	faChevronLeft,
	faChevronRight,
	faCaretRight,
	faFolder,
	faLock,
	faUnlock
);
